import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, buildError, API } from '../../api/apis';
import { ApiResponse, CreateTenantRequest, CreateTenantResponse } from '../../interfaces/interfaces';

// Define the RTK Query service for tenant
export const tenantService = createApi({
  reducerPath: 'tenantApi',
  tagTypes: ['Tenant'],
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    createTenant: builder.mutation({
      query: ({ payload, headers }: { payload: CreateTenantRequest; headers?: HeadersInit }) => ({
        url: API.CREATE_TENANT(),
        method: 'POST',
        body: payload,
        headers: {
          ...headers,
        },
      }),
      invalidatesTags: [{ type: 'Tenant', id: 'CREATE' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response as CreateTenantResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { useCreateTenantMutation } = tenantService;
